<template>
    <div class="step-timeline">
        <div class="step-timeline-start">
            <span>
                <i class="step-icon fa fa-flag-checkered"></i>
            </span>
        </div>

        <div
            v-for="step in progress.progressSteps"
            :key="step._id"
            :class="[
                'step-container',
                { 'step-completed': step.completed },
                { 'step-unlocked': step.unlocked },
            ]"
            tabindex="0"
            data-test-id="progress-timeline-step"
            @click="() => onStepClickHandler({ ...step, progressId: progress._id })"
            @keyup.enter="onStepClickHandler({ ...step, progressId: progress._id })"
        >
            <div class="index">
                <span>
                    <i :class="['step-icon', 'fa', `fa-${getIconFromStep(step)}`]"></i>
                </span>
            </div>
            <div class="step">
                <span class="step-name skill-title ellipsis">
                    {{ step.learningElementName }}
                </span>
            </div>
        </div>

        <div class="step-timeline-end">
            <span>
                <i class="step-icon fa fa-graduation-cap"></i>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        progress: {
            type: Object,
            required: true,
        },
        onStepClickHandler: {
            type: Function,
            default: () => {},
        },
    },
    methods: {
        getIconFromStep(step) {
            if (step.completed || step.unlocked) {
                return "check";
            } else {
                return "lock";
            }
        },
    },
};
</script>

<style scoped>
/* Show Full Path */
.step-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}

.step-timeline-start,
.step-timeline-end {
    background: linear-gradient(var(--color-grey), var(--color-grey)) no-repeat center/2px 100%;
    align-self: stretch;
    position: relative;
    width: 50px;
    height: 50px;
    margin-right: 12px;
}
.step-timeline-start span,
.step-timeline-end span {
    background-color: white;
    height: 35px;
    width: 35px;
    text-align: center;
    padding-top: 5px;
    font-size: 1.33rem;
    position: absolute;
    border: 1px solid var(--color-grey);
    border-radius: 100%;
    left: 8px;
}
.step-timeline-end span {
    bottom: 0;
}

.index {
    background: linear-gradient(var(--color-grey), var(--color-grey)) no-repeat center/2px 100%;
    align-self: stretch;
    position: relative;
    width: 50px;
    margin-right: 12px;
}

.index span {
    background-color: white;
    height: 50px;
    width: 50px;
    text-align: center;
    padding-top: 13px;
    font-size: 1.67rem;
    position: absolute;
    top: 8px;
    border: 1px dashed var(--color-grey);
    border-radius: 100%;
}
.index .step-icon {
    color: var(--color-grey);
    font-size: 2.2rem;
}

.step-unlocked .index span {
    border-style: solid;
}
.step-completed .index span {
    background-color: var(--color-green);
    border: 1px solid var(--color-green);
}
.step-completed .index .step-icon {
    color: var(--color-white);
}

.step {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;
    padding: 2rem;
    margin-bottom: 1rem;
    border: 1px solid var(--color-grey-light);
    border-radius: 12px;
}

.step-name {
    flex-grow: 1;
    max-width: 33vw; /* FIXME - Magic number ... */
}
</style>
